var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 16,
    fill: "#0FADFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.532 25.107a1.033 1.033 0 011.05-1.05l1.593.019c1.76.02 3.171-1.39 3.15-3.15a3.28 3.28 0 00-3.224-3.225l-1.594-.02a1.093 1.093 0 01-1.075-1.074 1.033 1.033 0 011.05-1.05l1.594.018c2.933.035 5.34 2.442 5.374 5.376a5.164 5.164 0 01-5.25 5.25l-1.593-.02a1.093 1.093 0 01-1.075-1.074zM17.675 23.976a1.093 1.093 0 011.075 1.075 1.033 1.033 0 01-1.05 1.05l-2.124-.025c-2.934-.035-5.341-2.442-5.376-5.375a5.164 5.164 0 015.25-5.25l2.126.024a1.093 1.093 0 011.075 1.075 1.033 1.033 0 01-1.05 1.05l-2.125-.024a3.098 3.098 0 00-3.15 3.15 3.28 3.28 0 003.224 3.225l2.125.024zM23.483 12.667c-.657-.632-1.352-.424-1.553.465l-1.276 5.632-1.276 5.633c-.202.889.167 2.121.824 2.753.657.632 1.352.424 1.553-.465l2.552-11.265c.202-.889-.167-2.121-.824-2.753z",
    fill: "#fff"
  })));
}
export default SvgEmbed;